<div class="visual-heading">
  <span>Definición de proyecto</span>
  <span class="status"><i></i> Alcance acordado</span>
</div>

<div class="project-flow" aria-hidden="true">
  <div class="flow-step source-step">
    <span class="step-label">Necesidad</span>
    <strong>Ordenar un proceso de empresa</strong>
    <div class="signal-lines"><i></i><i></i><i></i></div>
  </div>

  <span class="flow-connector"></span>

  <div class="flow-step scope-step">
    <span class="step-label">Propuesta</span>
    <strong>Objetivos y alcance claros</strong>
    <ul>
      <li><i></i> Prioridades definidas</li>
      <li><i></i> Entregables concretos</li>
      <li><i></i> Decisiones explicadas</li>
    </ul>
  </div>

  <span class="flow-connector"></span>

  <div class="flow-step result-step">
    <span class="step-label">Resultado</span>
    <strong>Solución preparada para trabajar</strong>
    <span class="result-window"><i></i><i></i><i></i></span>
  </div>
</div>

<div class="visual-summary">
  <div><span>Precio</span><strong>Cerrado</strong></div>
  <div><span>Proceso</span><strong>Comprensible</strong></div>
  <div><span>Entrega</span><strong>Consensuada</strong></div>
</div>
